import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manage-client-documents',
  templateUrl: './manage-client-documents.component.html',
  styleUrls: ['./manage-client-documents.component.css']
})
export class ManageClientDocumentsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
